export const ELECTION_YEAR = [
  { year: '2550', en: '2550', th: 'ปี 2550' },
  { year: '2554', en: '2554', th: 'ปี 2554' },
  { year: '2557', en: '2557', th: 'ปี 2557' },
  { year: '2562', en: '2562', th: 'ปี 2562' }
];
